import { render, staticRenderFns } from "./BoundaryFilter.vue?vue&type=template&id=2db02e8e&scoped=true"
import script from "./BoundaryFilter.vue?vue&type=script&lang=ts"
export * from "./BoundaryFilter.vue?vue&type=script&lang=ts"
import style0 from "./BoundaryFilter.vue?vue&type=style&index=0&id=2db02e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db02e8e",
  null
  
)

export default component.exports